var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOsmosisOsmoLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2500 2500",
    style: {
      enableBackground: "new 0 0 2500 2500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#602F92;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_00000165209464167014081150000008103851981390034055_);}\n\t.st3{opacity:0.6;fill:#A98798;enable-background:new    ;}\n\t.st4{opacity:0.6;fill:url(#SVGID_00000121253394352363390420000007219434812918878623_);enable-background:new    ;}\n\t.st5{opacity:0.6;fill:url(#SVGID_00000119080999294509003430000001963865163048886151_);enable-background:new    ;}\n\t.st6{fill:url(#SVGID_00000044152788990317576320000012040459717913800876_);}\n\t.st7{opacity:0.6;}\n\t.st8{opacity:0.6;fill:url(#SVGID_00000133516044930824863150000012384761495570139062_);enable-background:new    ;}\n\t.st9{opacity:0.7;}\n\t.st10{opacity:0.7;fill:url(#SVGID_00000139252545779526764080000009140375551033258133_);enable-background:new    ;}\n\t.st11{fill:url(#SVGID_00000164504295287222206440000011849616843794474920_);}\n\t.st12{fill:#FFFFFF;}\n\t.st13{opacity:0.6;fill:url(#SVGID_00000070085856523575142400000011383941088838273930_);enable-background:new    ;}\n\t.st14{opacity:0.2;fill:#FFFFFF;enable-background:new    ;}\n\t.st15{opacity:0.4;}\n\t.st16{opacity:0.6;fill:url(#SVGID_00000072960619083088660530000006265596681799660457_);enable-background:new    ;}\n\t.st17{opacity:0.3;fill:#FFFFFF;enable-background:new    ;}\n\t.st18{opacity:0.6;fill:url(#SVGID_00000070819380679104652690000017772091378003124361_);enable-background:new    ;}\n\t.st19{opacity:0.6;fill:url(#SVGID_00000168113551281912814290000000863467578844121780_);enable-background:new    ;}\n\t.st20{opacity:0.6;fill:url(#SVGID_00000152235364272686902710000012995088997398146455_);enable-background:new    ;}\n\t.st21{opacity:0.6;fill:url(#SVGID_00000130609004720181605890000018229579955204971399_);enable-background:new    ;}\n\t.st22{opacity:0.6;fill:url(#SVGID_00000084492812832115218250000010573727581686419378_);enable-background:new    ;}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2387.9,441.9c-25.4-98-107.1-196-254.2-305.1C2015.7,49.9,1890.4,0,1790.5,0c-20,0-38.1,1.8-56.3,5.5   c-45.4,9.2-85.3,42.5-110.8,92.5c-30.9,59.2-38.1,138.7-18.2,186.8c7.3,14.8,16.3,33.3,27.2,49.9c-96.2,59.2-150.7,75.8-158,77.7   c250.6,85.1,459.4,262.6,590.2,493.7l1.8-22.2c5.4-61,23.6-131.3,49-203.4c25.4,7.4,50.8,11.1,76.3,11.1   c67.2,0,125.3-27.7,161.6-77.7C2389.8,564,2404.3,497.4,2387.9,441.9z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 1036.4006,
    cy: 1693.469,
    r: 49.0196,
    gradientTransform: "matrix(16.5564 0 0 -16.8596 -14855.0654 28891.4922)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBEAF3",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6807,
    style: {
      stopColor: "#A087BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#17102E"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2126.5,626.9c165.2,46.2,232.4-83.2,210.6-170.1c-23.6-86.9-99.9-175.7-234.2-275.5   c-134.4-99.9-270.6-140.5-357.7-122c-87.2,18.5-112.6,153.5-90.8,205.3c9.1,20.3,29.1,49.9,56.3,83.2c-34.5,24-67.2,42.5-94.4,59.2   c167.1,75.8,312.3,194.2,421.3,342.1c12.7-49.9,30.9-94.3,47.2-133.1C2097.4,617.6,2111.9,621.3,2126.5,626.9z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000048501409467539029230000013863115645513551253_",
    cx: 976.1686,
    cy: 1671.8132,
    r: 49.0196,
    gradientTransform: "matrix(40.5074 0 0 -41.2493 -37689.5781 69653.75)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBEAF3",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6807,
    style: {
      stopColor: "#A087BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#17102E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000048501409467539029230000013863115645513551253_)"
    },
    d: "M1180.4,2439   c560.6,0,1015.1-462.8,1015.1-1033.7S1741,371.7,1180.4,371.7c-560.6,0-1015.1,462.8-1015.1,1033.7S619.8,2439,1180.4,2439z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2253.6,371.7c-138-147.9-254.2-186.8-394-218.2c-109-25.9-79.9-88.8,52.7-75.8   c-63.6-22.2-123.5-27.7-167.1-18.5c-87.2,18.5-112.6,153.5-90.8,205.3c9.1,20.3,29.1,49.9,56.3,83.2c-49,33.3-90.8,57.3-125.3,75.8   c16.3,7.4,36.3,16.6,59.9,29.6c61.7,33.3,128.9,88.8,128.9,88.8c-101.7-88.8-79.9-129.4,59.9-229.3   c43.6-31.4,123.5-27.7,197.9,11.1c74.4,38.8,161.6,136.8,161.6,136.8l-83.5,162.7c5.4,1.9,10.9,3.7,16.3,5.6   c52.7,14.8,94.4,11.1,127.1-1.9C2291.7,602.8,2391.6,521.4,2253.6,371.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1857.7,242.2c36.3,14.8,83.5,40.7,141.6,79.5c69,46.2,128.9,98,167.1,138.7   c-63.6,85.1-105.3,201.6-130.7,282.9c12.7,18.5,27.2,37,40,55.5c12.7-46.2,34.5-114.7,63.6-183.1c7.3,1.9,16.3,1.9,25.4,1.9   c21.8,0,47.2-3.7,67.2-20.3c14.5-11.1,30.9-31.4,29.1-68.4c0-35.1-27.2-79.5-83.5-133.1c-40-38.8-94.4-81.4-148.9-120.2   c-156.2-105.4-265.1-135-314.1-85.1c-32.7,33.3-29.1,74-18.2,103.6c-58.1,38.8-107.1,66.6-139.8,85.1c21.8,7.4,41.8,16.6,63.6,25.9   C1677.9,373.5,1761.5,319.9,1857.7,242.2z M2200.9,506.7c5.4,9.2,7.3,18.5,7.3,24c0,16.6-5.4,22.2-9.1,25.9   c-7.3,5.5-21.8,9.2-34.5,9.2C2175.5,543.6,2188.2,525.1,2200.9,506.7z M1752.4,231.1c5.4-5.5,20-9.2,43.6-5.5   c-18.2,14.8-36.3,27.7-54.5,40.7C1739.7,253.3,1741.5,240.4,1752.4,231.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1180.4,310.6c-593.8,0-1075,490-1075,1094.7c0,604.7,481.2,1094.7,1075,1094.7c593.8,0,1075-490,1075-1094.7   C2255.4,800.7,1772.4,310.6,1180.4,310.6z M1180.4,2439c-561.1,0-1015.1-462.3-1015.1-1033.7c0-571.4,454-1033.7,1015.1-1033.7   c561.1,0,1015.1,462.3,1015.1,1033.7C2195.4,1976.7,1739.7,2439,1180.4,2439z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024688497924610280600000018414514028729314984_",
    gradientUnits: "userSpaceOnUse",
    x1: 1012.1076,
    y1: 75.2612,
    x2: 1348.6737,
    y2: 2114.3088,
    gradientTransform: "matrix(1 0 0 -1 0 2500.1101)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9AD9E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6202,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000024688497924610280600000018414514028729314984_)",
      enableBackground: "new"
    },
    d: "   M1180.4,2439c560.6,0,1015.1-462.8,1015.1-1033.7S1741,371.7,1180.4,371.7c-560.6,0-1015.1,462.8-1015.1,1033.7   S619.8,2439,1180.4,2439z"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1173.1,2313.2c-553.8-90.6-929.7-621.3-838.9-1185.3c40-249.6,163.4-462.3,337.8-615.8   C417.7,662,228.9,922.7,178,1240.8c-89,564,286.9,1094.7,838.9,1185.3c308.7,51.8,606.5-46.2,826.2-238.5   C1648.9,2302.1,1412.8,2352.1,1173.1,2313.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000110430593634611892400000009687005377310453638_",
    gradientUnits: "userSpaceOnUse",
    x1: 1904.9932,
    y1: 1786.4968,
    x2: 1051.7273,
    y2: 1017.6793,
    gradientTransform: "matrix(1 0 0 -1 0 2500.1101)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000110430593634611892400000009687005377310453638_)",
      enableBackground: "new"
    },
    d: "   M1342,386.5c-256-42.5-504.8,16.6-708.2,147.9c-3.6,3.7-7.3,7.4-7.3,7.4c78.1-48.1,192.5-90.6,192.5-90.6   c-294.2,173.8-385,371.7-385,371.7c114.4-225.6,450.3-384.6,713.6-395.7c263.3-11.1,435.8,68.4,646.4,240.4   c210.6,173.8,337.8,528.8,325,809.9c-10.9,281.1-156.2,508.5-156.2,508.5c99.9-131.3,159.8-227.4,197.9-325.4   c7.3-29.6,14.5-59.2,18.2-90.6C2269.9,1007.8,1895.8,477.1,1342,386.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173855765166054213270000006009122785450557065_",
    gradientUnits: "userSpaceOnUse",
    x1: 214.3642,
    y1: 613.0974,
    x2: 2144.6152,
    y2: 613.0974,
    gradientTransform: "matrix(1 0 0 -1 0 2500.1101)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#384EA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9952,
    style: {
      stopColor: "#D54799"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173855765166054213270000006009122785450557065_)"
    },
    d: "M2144.6,1396.1   c0,541.8-432.2,981.9-964.2,981.9c-532,0-966-440.1-966-981.9H2144.6z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108988677220751402100000012584116721026725252_",
    gradientUnits: "userSpaceOnUse",
    x1: 2240.8235,
    y1: 1012.0823,
    x2: 1172.9314,
    y2: 21.0224,
    gradientTransform: "matrix(1 0 0 -1 0 2500.1101)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000108988677220751402100000012584116721026725252_)",
      enableBackground: "new"
    },
    d: "    M2068.3,1396.1c0,528.8-410.4,961.5-926.1,981.9c12.7,0,25.4,0,38.1,0c532,0,964.2-440.1,964.2-981.9H2068.3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145777165761329904110000017200055933317790117_",
    gradientUnits: "userSpaceOnUse",
    x1: 214.3642,
    y1: 613.0974,
    x2: 1245.7673,
    y2: 613.0974,
    gradientTransform: "matrix(1 0 0 -1 0 2500.1101)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B2F82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9952,
    style: {
      stopColor: "#72439A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "url(#SVGID_00000145777165761329904110000017200055933317790117_)",
      enableBackground: "new"
    },
    d: "    M350.6,1396.1H214.4c0,541.8,432.2,981.9,964.2,981.9c23.6,0,45.4,0,67.2-1.9C746.4,2339.1,350.6,1913.8,350.6,1396.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032649099069912955770000015870088104982849928_",
    gradientUnits: "userSpaceOnUse",
    x1: 216.4757,
    y1: 1013.8193,
    x2: 2142.8508,
    y2: 1013.8193,
    gradientTransform: "matrix(1 0 0 -1 0 2500.1101)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B2F82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9952,
    style: {
      stopColor: "#A14298"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000032649099069912955770000015870088104982849928_)"
    },
    d: "M2142.8,1405.3   c0-112.8-192.5-177.5-448.5-199.7c-185.2-14.8-372.2,3.7-586.5,70.3c-185.2,55.5-352.3,46.2-473.9,31.4   c-270.6-31.4-419.5-35.1-419.5,98c0,192.3,385,432.7,962.4,349.5c292.4-42.5,443.1-129.4,615.6-188.6   C1979.4,1503.3,2142.8,1505.2,2142.8,1405.3z"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1496.3,939.3c90.3,0,163.4-74.5,163.4-166.4s-73.2-166.4-163.4-166.4s-163.4,74.5-163.4,166.4   S1406.1,939.3,1496.3,939.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1763.3,1063.2c38.1,0,69-31.5,69-70.3c0-38.8-30.9-70.3-69-70.3c-38.1,0-69,31.5-69,70.3   C1694.3,1031.8,1725.2,1063.2,1763.3,1063.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086685360016755455480000008623335496992819094_",
    gradientUnits: "userSpaceOnUse",
    x1: 2113.7773,
    y1: 2063.7463,
    x2: 1971.651,
    y2: 1836.9449,
    gradientTransform: "matrix(1 0 0 -1 0 2500.1101)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000086685360016755455480000008623335496992819094_)",
      enableBackground: "new"
    },
    d: "    M2010.2,639.8c-1.8,0-3.6,0-3.6,0c-10.9-1.9-18.2-12.9-16.3-25.9c16.3-85.1,85.3-166.4,89-170.1c7.3-9.2,21.8-9.2,29.1-1.9    c9.1,7.4,9.1,22.2,1.8,29.6c-1.8,1.8-65.4,77.7-79.9,151.6C2028.4,634.2,2019.3,639.8,2010.2,639.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1113.3,2176.4c28.1,0,50.8-23.2,50.8-51.8c0-28.6-22.8-51.8-50.8-51.8c-28.1,0-50.8,23.2-50.8,51.8   C1062.5,2153.2,1085.2,2176.4,1113.3,2176.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120520711239065630940000002186392509236582834_",
    gradientUnits: "userSpaceOnUse",
    x1: 1061.9132,
    y1: 375.0254,
    x2: 1138.7391,
    y2: 375.0254,
    gradientTransform: "matrix(1 0 0 -1 0 2500.1101)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000120520711239065630940000002186392509236582834_)",
      enableBackground: "new"
    },
    d: "    M1084.2,2158c-20-20.3-20-53.6,0-74c3.6-3.7,7.3-5.5,10.9-9.2c-7.3,1.9-12.7,5.5-18.2,11.1c-20,20.3-20,53.6,0,74    c16.3,16.6,41.8,20.3,61.7,9.2C1120.5,2176.5,1098.7,2172.8,1084.2,2158z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1131.4,2109.8c6,0,10.9-5,10.9-11.1c0-6.1-4.9-11.1-10.9-11.1c-6,0-10.9,5-10.9,11.1   C1120.5,2104.9,1125.3,2109.8,1131.4,2109.8z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1378.4,2150.5c28.1,0,50.8-23.2,50.8-51.8c0-28.6-22.8-51.8-50.8-51.8c-28.1,0-50.8,23.2-50.8,51.8   C1327.6,2127.3,1350.4,2150.5,1378.4,2150.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031203203710109173300000008480740637077649066_",
    gradientUnits: "userSpaceOnUse",
    x1: 1326.7906,
    y1: 400.92,
    x2: 1403.6167,
    y2: 400.92,
    gradientTransform: "matrix(1 0 0 -1 0 2500.1101)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000031203203710109173300000008480740637077649066_)",
      enableBackground: "new"
    },
    d: "    M1349.3,2132.1c-20-20.3-20-53.6,0-74c3.6-3.7,7.3-5.5,10.9-9.2c-7.3,1.9-12.7,5.5-18.2,11.1c-20,20.3-20,53.6,0,74    c16.3,16.6,41.8,20.3,61.7,9.2C1385.6,2150.6,1363.8,2146.9,1349.3,2132.1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1396.5,2084c6,0,10.9-5,10.9-11.1c0-6.1-4.9-11.1-10.9-11.1c-6,0-10.9,5-10.9,11.1   C1385.6,2079,1390.5,2084,1396.5,2084z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1247.6,2270.7c21.1,0,38.1-17.4,38.1-38.8s-17.1-38.8-38.1-38.8c-21.1,0-38.1,17.4-38.1,38.8   S1226.5,2270.7,1247.6,2270.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000110453750317046297840000005051228349683967895_",
    gradientUnits: "userSpaceOnUse",
    x1: 1209.2109,
    y1: 267.1414,
    x2: 1266.8887,
    y2: 267.1414,
    gradientTransform: "matrix(1 0 0 -1 0 2500.1101)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000110453750317046297840000005051228349683967895_)",
      enableBackground: "new"
    },
    d: "    M1225.8,2256c-14.5-14.8-14.5-40.7,0-55.5c1.8-1.9,5.4-3.7,7.3-5.6c-5.4,1.9-9.1,5.6-12.7,9.2c-14.5,14.8-14.5,40.7,0,55.5    c12.7,12.9,30.9,14.8,47.2,5.6C1253,2270.8,1236.7,2267.1,1225.8,2256z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1260.3,2218.9c4,0,7.3-3.3,7.3-7.4c0-4.1-3.3-7.4-7.3-7.4c-4,0-7.3,3.3-7.3,7.4   C1253,2215.6,1256.3,2218.9,1260.3,2218.9z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1481.8,2243c21.1,0,38.1-17.4,38.1-38.8s-17.1-38.8-38.1-38.8s-38.1,17.4-38.1,38.8S1460.8,2243,1481.8,2243   z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180333987652615850970000003356259407690098071_",
    gradientUnits: "userSpaceOnUse",
    x1: 1442.6914,
    y1: 294.8761,
    x2: 1500.3629,
    y2: 294.8761,
    gradientTransform: "matrix(1 0 0 -1 0 2500.1101)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000180333987652615850970000003356259407690098071_)",
      enableBackground: "new"
    },
    d: "    M1460.1,2228.2c-14.5-14.8-14.5-40.7,0-55.5c1.8-1.9,5.4-3.7,7.3-5.5c-5.4,1.9-9.1,5.5-12.7,9.2c-14.5,14.8-14.5,40.7,0,55.5    c12.7,12.9,30.9,14.8,47.2,5.5C1487.3,2243,1471,2239.3,1460.1,2228.2z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1494.5,2191.2c4,0,7.3-3.3,7.3-7.4c0-4.1-3.3-7.4-7.3-7.4c-4,0-7.3,3.3-7.3,7.4   C1487.3,2187.9,1490.5,2191.2,1494.5,2191.2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M897.1,2157.9c46.1,0,83.5-38.1,83.5-85.1c0-47-37.4-85.1-83.5-85.1c-46.1,0-83.5,38.1-83.5,85.1   C813.6,2119.8,851,2157.9,897.1,2157.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000074407529416263320170000015271204216423616654_",
    gradientUnits: "userSpaceOnUse",
    x1: 813.7147,
    y1: 424.835,
    x2: 939.1743,
    y2: 424.835,
    gradientTransform: "matrix(1 0 0 -1 0 2500.1101)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000074407529416263320170000015271204216423616654_)",
      enableBackground: "new"
    },
    d: "    M850,2126.5c-32.7-33.3-32.7-86.9,0-120.2c5.4-5.5,10.9-9.2,18.2-12.9c-10.9,3.7-20,11.1-29.1,18.5c-32.7,33.3-32.7,86.9,0,120.2    c27.2,27.7,69,33.3,101.7,12.9C909.9,2157.9,873.6,2152.4,850,2126.5z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M926.2,2047c10,0,18.2-8.3,18.2-18.5c0-10.2-8.1-18.5-18.2-18.5c-10,0-18.2,8.3-18.2,18.5   C908,2038.7,916.1,2047,926.2,2047z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1643.5,1949c46.1,0,83.5-38.1,83.5-85.1c0-47-37.4-85.1-83.5-85.1c-46.1,0-83.5,38.1-83.5,85.1   C1560,1910.9,1597.3,1949,1643.5,1949z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031194797927281050290000012460565261675033278_",
    gradientUnits: "userSpaceOnUse",
    x1: 1558.8556,
    y1: 633.7911,
    x2: 1684.3213,
    y2: 633.7911,
    gradientTransform: "matrix(1 0 0 -1 0 2500.1101)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2888,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000031194797927281050290000012460565261675033278_)",
      enableBackground: "new"
    },
    d: "    M1594.4,1917.5c-32.7-33.3-32.7-86.9,0-120.2c5.4-5.6,10.9-9.2,18.2-12.9c-10.9,3.7-20,11.1-29.1,18.5    c-32.7,33.3-32.7,86.9,0,120.2c27.2,27.7,69,33.3,101.7,12.9C1654.3,1949,1619.8,1943.4,1594.4,1917.5z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1672.5,1838c10,0,18.2-8.3,18.2-18.5c0-10.2-8.1-18.5-18.2-18.5c-10,0-18.2,8.3-18.2,18.5   C1654.3,1829.7,1662.4,1838,1672.5,1838z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOsmosisOsmoLogo);
export default __webpack_public_path__ + "static/media/osmosis-osmo-logo.e63cfefeb2a04452c70bc79d10edca03.svg";
export { ForwardRef as ReactComponent };